import { Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, OutlinedInput, InputAdornment, IconButton, FormHelperText } from "@mui/material";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { LinearProgress } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { FormHandles } from "@unform/core";
import jwt_decode from "jwt-decode";
import { Form } from "@unform/web";
import * as yup from 'yup';

import { UsuarioService } from "../shared/services/api/usuario/UsuarioService";
import { AlertSnackBar, FerramentaDeDetalhe } from "../shared/components";
import { LayoutBaseDePagina } from "../shared/layouts";

import { VTextField } from "../shared/forms";
import { Environment } from "../shared/environment";
import { TJwtToken } from '../shared/services/api/usuario/auth/AuthService';
import { CampoTextoMascarado } from "../shared/components/campo-texto-mascarado/CampoTextoMascarado";

interface IFormData {
    cpf: string;
    nome: string;
    email: string;
    celular: string;
    uf: string;
    senha?: string;
    alterarSenha?: boolean;
}

const formValidationSchema = yup.object().shape({
    cpf: yup.string().required().min(11),
    nome: yup.string().required('Nome é obrigatório'),
    email: yup.string().required('Email é obrigatório').email('Digite um email válido'),
    celular: yup.string().required().min(11),
    uf: yup.string().required(),
});

export const EditarDadosUsuarioLogado: React.FC = () => {
    // @ts-expect-error
    var decoded: TJwtToken = jwt_decode(localStorage.getItem("ACESS_TOKEN"));
    const idUsuario = decoded.name;
    const navigate = useNavigate();
    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const formRef = useRef<FormHandles>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [cpf, setCpf] = useState('');
    const [celular, setCelular] = useState('');

    const [errorCpf, setErrorCpf] = useState(false);
    const [errorCelular, setErrorCelular] = useState(false);

    const [maskedCpf, setMaskedCpf] = useState('');
    const [maskedCelular, setMaskedCelular] = useState('');

    const [uf, setUf] = useState('');
    const [errorUf, setErrorUf] = useState(false);

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const alterarSenha = !!JSON.parse(localStorage.getItem('AlterarSenha') ?? "false");

    let podeSalvar = true;

    const handleChangeUf = (event: SelectChangeEvent) => {
        setUf(event.target.value as string);
        setErrorUf(false);
    };

    const handleChangeCpf = (valorMascarado: string) => {
        setMaskedCpf(valorMascarado);
        setErrorCpf(false);
    };
    const handleChangeCelular = (valorMascarado: string) => {
        setMaskedCelular(valorMascarado);
        setErrorCelular(false);
    };

    useEffect(() => {
        setIsLoading(true);
        setNome("Carregando...")

        UsuarioService.getById(idUsuario)
            .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert)
                } else {
                    setNome(result.nome);

                    //pegar os dados que não podem ser iguais para não serem enviados na request
                    setEmail(result.email);
                    setCpf(result.cpf);
                    setCelular(result.celular);// saber se o telefone foi alterado para retirar a mascara

                    //setar os dados nos campos
                    formRef.current?.setData(result);
                    setUf(result.uf);

                    setMaskedCpf(result.cpf);
                    setMaskedCelular(result.celular);

                }
            });

    }, []);


    const handleSave = (dados: IFormData) => {
        //retirar máscaras
        let unmaskedCpf = maskedCpf.replaceAll('.', '');
        unmaskedCpf = unmaskedCpf.replaceAll('-', '');
        unmaskedCpf = unmaskedCpf.replaceAll('_', '');
        dados.cpf = unmaskedCpf;

        let unmaskedCelular = maskedCelular.replace('(', '');
        unmaskedCelular = unmaskedCelular.replace(')', '');
        unmaskedCelular = unmaskedCelular.replaceAll(' ', '');
        unmaskedCelular = unmaskedCelular.replace('-', '');
        unmaskedCelular = unmaskedCelular.replaceAll('_', '');
        dados.celular = unmaskedCelular;

        dados.uf = uf;

        formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
            if (email == dados.email) { // se não foi alterado, retira do objeto da request
                // @ts-expect-error 
                delete dados.email;
            }

            //se não foi alterado, não adiciona no objeto da request
            if (cpf === maskedCpf) {
                // @ts-expect-error 
                delete dados.cpf;
            }
            if (celular === maskedCelular) {
                // @ts-expect-error 
                delete dados.celular;
            }

            if (alterarSenha && password === '') {// se o usuario tiver pedido pra alterar a senha é obrigatório
                setPasswordError("Você prescisa redefinir sua senha");
                podeSalvar = false
            } else {
                podeSalvar = true;
                dados.senha = password;
            }

            if (!alterarSenha && password !== '') {
                dados.senha = password;
            }

            if (podeSalvar) {
                setIsLoading(true);
                UsuarioService.updateById(idUsuario, { idUsuario: idUsuario, ...dados }).then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert)
                    } else {
                        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Dados alterados com sucesso" });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert)
                        setNome(dados.nome);
                        if (alterarSenha) {
                            // localStorage.removeItem("AlterarSenha");
                            localStorage.setItem("AlterarSenha", "false");
                            navigate(0);
                        }
                    }
                });
            }

        }).catch((errors: yup.ValidationError) => {
            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;

                validationErrors[error.path] = error.message;
                if (error.path === "uf") setErrorUf(true);
                if (error.path === "cpf") setErrorCpf(true);
                if (error.path === "celular") setErrorCelular(true);
            });

            formRef.current?.setErrors(validationErrors);
            if (alterarSenha && password === '') setPasswordError("Você prescisa redefinir sua senha")

        });

    }

    return (

        <LayoutBaseDePagina
            titulo={nome}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}

                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={() => formRef.current?.submitForm()}
                    aoClicarEmSalvarEVoltar={() => formRef.current?.submitForm()}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            {alterarSenha && (
                <AlertSnackBar gravidade="warning" mensagem="Você prescisa redefinir sua senha para continuar usando o sistema" duracao={10000} />
            )}
            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                {alertSnackbar !== undefined && (
                    <>
                        {alertSnackbar.tipoAlert === "sucesso" && (
                            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                        )}
                        {alertSnackbar.tipoAlert === "erro" && (
                            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                        )}
                        {alertSnackbar.tipoAlert === "aviso" && (
                            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                        )}
                    </>
                )}


                <Form ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid container item direction="row" spacing={2}>

                            <Grid item xs={12} sm={12} md={4}>
                                <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nome" disabled={isLoading} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <CampoTextoMascarado
                                    fullWidth
                                    mask="999.999.999-99"
                                    label="CPF"
                                    name="cpf"
                                    disabled={isLoading}
                                    error={errorCpf}
                                    helperText={errorCpf && "Digite um CPF válido"}
                                    value={maskedCpf}
                                    onChange={(valorMascarado) => handleChangeCpf(valorMascarado)}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item direction="row" spacing={2}>
                            <Grid item xs={12} sm={12} md={4}>
                                <VTextField fullWidth label="Email" placeholder="Digite o email..." name="email" disabled={isLoading} autoComplete='off' />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <CampoTextoMascarado
                                    fullWidth
                                    mask="(99) \9 9999-9999"
                                    label="Celular"
                                    name="celular"
                                    disabled={isLoading}
                                    error={errorCelular}
                                    helperText={errorCelular && "Digite todos os números do celular"}
                                    value={maskedCelular}
                                    onChange={(valorMascarado) => handleChangeCelular(valorMascarado)}
                                />
                            </Grid>

                            <Grid container item direction="row" spacing={2}>

                                <Grid item xs={12} sm={12} md={4} lg={2}>

                                    <FormControl fullWidth>
                                        <InputLabel id="select-component-label"> UF </InputLabel>
                                        <Select
                                            labelId="select-component-label"
                                            id="select"
                                            label="UF"
                                            disabled={isLoading}
                                            value={uf}
                                            onChange={handleChangeUf}

                                            error={errorUf}//  se tiver algum erro
                                        >
                                            <MenuItem value={"AC"}>AC</MenuItem>
                                            <MenuItem value={"AL"}>AL</MenuItem>
                                            <MenuItem value={"AM"}>AM</MenuItem>
                                            <MenuItem value={"AP"}>AP</MenuItem>
                                            <MenuItem value={"BA"}>BA</MenuItem>
                                            <MenuItem value={"CE"}>CE</MenuItem>
                                            <MenuItem value={"DF"}>DF</MenuItem>
                                            <MenuItem value={"ES"}>ES</MenuItem>
                                            <MenuItem value={"GO"}>GO</MenuItem>
                                            <MenuItem value={"MA"}>MA</MenuItem>
                                            <MenuItem value={"MG"}>MG</MenuItem>
                                            <MenuItem value={"MS"}>MS</MenuItem>
                                            <MenuItem value={"MT"}>MT</MenuItem>
                                            <MenuItem value={"PA"}>PA</MenuItem>
                                            <MenuItem value={"PB"}>PB</MenuItem>
                                            <MenuItem value={"PE"}>PE</MenuItem>
                                            <MenuItem value={"PI"}>PI</MenuItem>
                                            <MenuItem value={"PR"}>PR</MenuItem>
                                            <MenuItem value={"RJ"}>RJ</MenuItem>
                                            <MenuItem value={"RN"}>RN</MenuItem>
                                            <MenuItem value={"RO"}>RO</MenuItem>
                                            <MenuItem value={"RR"}>RR</MenuItem>
                                            <MenuItem value={"RS"}>RS</MenuItem>
                                            <MenuItem value={"SC"}>SC</MenuItem>
                                            <MenuItem value={"SE"}>SE</MenuItem>
                                            <MenuItem value={"SP"}>SP</MenuItem>
                                            <MenuItem value={"TO"}>TO</MenuItem>
                                        </Select>
                                        {errorUf && (
                                            <FormHelperText error>Selecione um estado</FormHelperText>
                                        )}
                                    </FormControl>

                                </Grid>



                                <Grid item xs={12} sm={12} md={4} lg={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="campoSenha"> Nova senha </InputLabel>
                                        <OutlinedInput
                                            id="campoSenha"
                                            fullWidth
                                            label="Nova senha"
                                            placeholder="Digite a nova senha..."
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                            onKeyDown={e => setPasswordError('')}
                                            disabled={isLoading}
                                            error={!!passwordError}
                                            autoComplete='off'
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={e => setShowPassword(!showPassword)}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        {!!passwordError && (
                                            <FormHelperText error id="accountId-error">
                                                {passwordError}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </Form>

            </Box>

        </LayoutBaseDePagina>
    )
}
